import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum ComponentsNamespaceErrorCode {
  UnknownComponentSetProp = 'UnknownComponentSetProps',
  UnknownComponentGetProp = 'UnknownComponentGetProps',
  UnknownSetProp = 'UnknownSetProp',
}

class ComponentsNamespaceError extends BaseError<ComponentsNamespaceErrorCode> {
  constructor(message: string, code: ComponentsNamespaceErrorCode) {
    super(message, code, 'EP ComponentsNamespace Error');
  }
}

export const createComponentsNamespaceError = createErrorBuilder<
  ComponentsNamespaceErrorCode,
  ComponentsNamespaceError
>(ComponentsNamespaceError);
